document.addEventListener('DOMContentLoaded', function () {
  var bars = document.querySelectorAll('[data-product-sticky-cart]');
  if (!bars.length) return;

  bars.forEach(function (bar) {
    var formId = bar.getAttribute('data-product-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var watchTarget = form ? form.querySelector('[type="submit"]') : null;

    if (!watchTarget || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var shouldShow = !entry.isIntersecting && window.innerWidth < 750;
          bar.classList.toggle('is-visible', shouldShow);
        });
      },
      { threshold: 0 }
    );

    observer.observe(watchTarget);

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 750) {
        bar.classList.remove('is-visible');
      }
    });
  });
});
